import React, { Component } from 'react'
import Fab from '@material-ui/core/Fab';
import { connect } from 'react-redux';
import * as vendorRateActions from '../../../../store/actions/vendorRates';
import history from '../../../../history';

const mapStateToProps = (state) => {
    return {
        submitting: state.vendorRateForm.submitting,
        isEditing: state.vendorRateForm.id
    }
};

const mapDispatchToProps = (dispatch) => ({
    submitFormStarted: () => 
        dispatch(vendorRateActions.vendorRatesFormSubmitStarted()),
    resetForm: () => 
        dispatch(vendorRateActions.resetVendorRatesForm())
    }
);

class FormSubmitPanelContainer extends Component {
    cancelForm = () => {
        this.props.resetForm();
        history.push('/masterdata/viewallvendorrates');
    }
    submitForm = () => {
        this.props.submitFormStarted();
    }

    render() {
        return (
            <div style={{display: 'flex', justifyContent: 'flex-end', marginBottom: 100}}>
                <Fab variant="extended" className="form-submit-panel form-cancel" onClick={this.cancelForm}>Cancel</Fab>
                <Fab disabled={this.props.submitting} variant="extended" className="form-submit-panel form-submit" onClick={this.submitForm}>Submit</Fab>
            </div>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FormSubmitPanelContainer);